import React, { useState, useRef, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import phone from "../assets/phone.png";
import "../styles/donate.css";

export default function Donate() {
  const [amount, setAmount] = useState("");
  const phoneRef = useRef(null);

  useEffect(() => {
    if (phoneRef.current) {
      setTimeout(() => {
        phoneRef.current.classList.add("phone-search");
      }, 1);
    }
  }, []);

  const handleDonate = async () => {
    if (!amount || parseFloat(amount) <= 0) {
      alert("Please enter a valid donation amount");
      return;
    }

    const response = await fetch("https://hokiehelper.com/api/create-checkout-session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ amount }),
    });

    const data = await response.json();
    if (data.url) {
      window.location.href = data.url;
    } else {
      alert("Error creating checkout session");
    }
  };

  return (
    <div className="donate">
      <Header />
      <div className="donate-body">
        <div className="donate-container">
          <div className="donate-text">
            <h1>Support Hokie Helper</h1>
            <h2>
              Your donation helps us maintain and improve our service for all Hokies
            </h2>
            <div className="donate-form">
              <div className="input-group">
                <span className="currency-symbol">$</span>
                <input
                  type="number"
                  placeholder="Enter donation amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  min="0.01"
                  step="0.01"
                />
              </div>
              <button
                onClick={handleDonate}
                className="primary-button"
              >
                Donate
              </button>
            </div>
          </div>
        </div>
        <div className="donate-assets">
          <img src={phone} alt="Phone" className="phone" ref={phoneRef} />
        </div>
      </div>
      <Footer />
    </div>
  );
}

